const getHttpBaseUrl = (): string => {
  const raw = import.meta.env.VITE_BRAINIACS_CORE_URL || '';
  return raw.replace(/\/+$/, '');
};

export const getCoreHttpBaseUrl = (): string => getHttpBaseUrl();

export const getCoreWsUrl = (): string => {
  const httpBase = getHttpBaseUrl();
  return `${httpBase.replace(/^http/, 'ws')}/ws`;
};
